import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Typography } from "@mui/material";
import DataTable from "../../../Components/Table/Table";
import DropDown from "../../../Components/DropDown/DropDown";
import SearchBar from "../../../Components/SearchBar/SearchBar";
import AddButton from "../../../Components/AddButton/AddButton";
import Paginations from "../../../Components/Pagination/Pagination";
import hospitalImage from "./../../../Assets/Hospital/mykare-hospital.png";

function Agreements({ isModal }) {
  const navigate = useNavigate();
  const navigateTo = () => {
    navigate("/HospitalAddPage");
  };
  const [tableHeader, setTableHeader] = useState([
    {
      id: 1,
      headText1: "City Name",
      headText2: "state",
      headText3: "country",
      headText4: "Approval",
      headText5: "",
    },
  ]);
  const [hospitalData, setHospitalData] = useState([
    {
      id: 1,
      cellItem1: "Indraprastha Apollo Hospital",
      cellItem2: "Greams Road, Chennai",
      cellItem3: "india",
      cellItem4: "Approved",
    },
    {
      id: 2,
      cellItem1: "Indraprastha Apollo Hospital",
      cellItem2: "Greams Road, Chennai",
      cellItem3: "India",
      cellItem4: "Approved",
    },
    {
      id: 3,
      cellItem1: "Indraprastha Apollo Hospital",
      cellItem2: "Greams Road, Chennai",
      cellItem3: "India",
      cellItem4: "Approved",
    },
    {
      id: 4,
      cellItem1: "Indraprastha Apollo Hospital",
      cellItem2: "Greams Road, Chennai",
      cellItem3: "India",
      cellItem4: "Approved",
    },
    {
      id: 5,
      cellItem1: "Indraprastha Apollo Hospital",
      cellItem2: "Greams Road, Chennai",
      cellItem3: "India",
      cellItem4: "Approved",
    },
    {
      id: 6,
      cellItem1: "Indraprastha Apollo Hospital",
      cellItem2: "Greams Road, Chennai",
      cellItem3: "India",
      cellItem4: "Approved",
    },
    {
      id: 7,
      cellItem1: "Indraprastha Apollo Hospital",
      cellItem2: "Greams Road, Chennai",
      cellItem3: "India",
      cellItem4: "Approved",
    },
    {
      id: 8,
      cellItem1: "Indraprastha Apollo Hospital",
      cellItem2: "Greams Road, Chennai",
      cellItem3: "India",
      cellItem4: "Approved",
    },
    {
      id: 9,
      cellItem1: "Indraprastha Apollo Hospital",
      cellItem2: "Greams Road, Chennai",
      cellItem3: "India",
      cellItem4: "Approved",
    },
    {
      id: 10,
      cellItem1: "Indraprastha Apollo Hospital",
      cellItem2: "Greams Road, Chennai",
      cellItem3: "India",
      cellItem4: "Approved",
    },
  ]);
  return (
    <Grid
      sx={{
        width: "77%",
        height: "98vh",
        padding: "0px 25px",
      }}
    >
      <Grid
        sx={{
          width: "100%",
          height: "100%",
          backgroundColor: "#f9fbfc",
          borderRadius: "15px",
          padding: "20px",
        }}
      >
        <Grid lg={12} sx={{ height: "100px" }} container alignItems={"center"}>
          <Grid item lg={2.3}>
            <Typography
              style={{ color: "black", fontWeight: "600", fontSize: "20px" }}
            >
              Doctors
            </Typography>
          </Grid>
          <Grid item lg={2.3}>
            <SearchBar width={250} />
          </Grid>
          <Grid item lg={1.9}>
            <DropDown
              placeHolder="Select Hospital"
              viewHeight={"40px"}
              borderRadius={"50px"}
              bgColor="#ecf1f5"
            />
          </Grid>
          <Grid item lg={1.9}>
            <DropDown
              placeHolder="Select State"
              viewHeight={"40px"}
              borderRadius={"50px"}
              bgColor="#ecf1f5"
            />
          </Grid>
          <Grid item lg={1.9}>
            <DropDown
              placeHolder="Select Insurance"
              viewHeight={"40px"}
              borderRadius={"50px"}
              bgColor="#ecf1f5"
            />
          </Grid>
          <Grid item lg={1.7} onClick={() => isModal(true)}>
            <AddButton
              labelName={"Add New Hospital"}
              navigateTo={navigateTo}
              viewHeight={"40px"}
              borderRadius={"50px"}
            />
          </Grid>
        </Grid>
        <DataTable
          isModal={isModal}
          tableHeader={tableHeader}
          data={hospitalData}
          setData={setHospitalData}
        />
        <Grid
          sx={{ height: "88px", width: "100%" }}
          container
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Paginations />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Agreements;
